import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { ROUTE_PATHS } from '../routing/route-paths';
import { AuthSessionFacade } from './auth-session.facade';

export const superAdminGuard: CanActivateFn = () => {
  const authFacade = inject(AuthSessionFacade);
  const router = inject(Router);

  if (!authFacade.isAuthenticated()) {
    return router.createUrlTree([ROUTE_PATHS.LOGIN]);
  }

  if (authFacade.isSuperAdmin()) {
    return true;
  }

  return router.createUrlTree([authFacade.getDefaultRoute()]);
};
